import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { fetchApi, getEndDateAfter12Months } from '../../../utils/methods'
import { toast } from 'react-toastify'
// import CompanyMedalCardsDashboard from '../components/CompanyMedalCardsDashboard'
import { ConfigureRewards, RewardsDashboard } from './styles'
import SkeletonLoder from '../../common/skeletonLoder'
import {CommonButtonPopup} from '../../ReportsV2/styles'
import TiersModal from './TiersModal'
import CompanyMedalCardsSlider from './CompanyMedalCardsSlider'
import { GetCompanyAdminRewardTier, GetSpotPointsAwarded ,GetSpotPointsLeaders} from '../../../redux/constants/apiConstants'
import MonthRangeModal from './MonthRangeModal'
import ConfirmPlanModal from './ConfirmPlanModal'
import { ImageUrl } from '../../../utils/constants'
import dayjs from 'dayjs'
import SpotPointsDashboard from './SpotPointsDashboard';


const Rewards = ({selectedYear, companyInfo,history}) => {
  const [companyRewardDetails, setCompanyRewardDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showTiersModal, setShowTiersModal] = useState(false);
  const [tierConfig, setTierConfig] = useState('new');
  const [showMonthRangeModal, setShowMonthRangeModal] = useState(false);
  const[showPlanConfirmModal,setShowPlanConfirmModal] = useState(false);
  const[selectedStartMonth, setSelectedStartMonth] = useState(false);
  const[selectedEndMonth, setSelectedEndMonth] = useState(false);
  const[selectedPoints, setSelectedPoints] = useState();
  const [selectedPlan, setSelectedPlan] = useState('custom');
  const[tierConfigDetails, setTierConfigDetails] = useState();
  const [spotPointsAwrded,setSpotPointsAwarded] = useState(null);
  const [spotPointsLeaders,setSpotPointsLeaders] = useState(null);

  useEffect(() => {
    if (companyInfo?.id && selectedYear?.reward_period_id) {
      fetchCompanyRewardsDetailsYearwise(selectedYear);
      GetAwardedSpotPoints(companyInfo?.id);
      FetchSpotPointsLeaders(companyInfo?.id);
    }
  }, [selectedYear, companyInfo?.id]);

  
  const onMonthChange = (item)=>{
    setSelectedStartMonth(item);
    const endDate = getEndDateAfter12Months(item?.firstDate)
    setSelectedEndMonth(endDate)
  }


  const GetAwardedSpotPoints = async (companyId , selectedRewardProgram=selectedYear) => {
    // const rewardPeriodId = selectedRewardProgram.status === 'active' ? '' : selectedRewardProgram?.reward_period_id;
    const rewardPeriodId = selectedRewardProgram?.reward_period_id;
    const apiUrl = `${GetSpotPointsAwarded}?company_id=${companyId}&reward_period_id=${rewardPeriodId}`;
  
    try {
      const res = await fetchApi(apiUrl, "GET");
  
      if (res.status === "success") {
        setSpotPointsAwarded(res?.data);
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      window.console.error(error);
    }
  };



  const FetchSpotPointsLeaders = async (companyId , selectedRewardProgram=selectedYear) => {
    // const rewardPeriodId = selectedRewardProgram.status === 'active' ? '' : selectedRewardProgram?.reward_period_id;
    const rewardPeriodId = selectedRewardProgram?.reward_period_id;
    const payload = {
      company_id: companyId,
      reward_period_id: rewardPeriodId,
      page: 1,
      limit: 5,
      search: "",
      department_ids: [],
      location_ids: []
    }

    const apiUrl = `${GetSpotPointsLeaders}`;
    try {
      const res = await fetchApi(apiUrl, "POST", payload);
  
      if (res.status === "success") {
        setSpotPointsLeaders(res?.data?.users);
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      window.console.error(error);
    }
  };
  
  

  const fetchCompanyRewardsDetailsYearwise = async(selectedRewardProgram=selectedYear) =>{
    const rewardPeriodId = selectedRewardProgram?.status === 'active' ? '' : selectedRewardProgram?.reward_period_id;
    setLoading(true);
    try {

      const companyRewardsData = await fetchApi(GetCompanyAdminRewardTier+'?company_id='+ companyInfo.id + (rewardPeriodId ? `&reward_period_id=${rewardPeriodId}`:''), "GET");
      if(companyRewardsData.status === 'success'){
        setCompanyRewardDetails(companyRewardsData.data);
      }else{
        toast.error(companyRewardsData.message);
      }
    } catch (error) {
      toast.error(error);
      
    }finally{
      setLoading(false);
    }
  }

  const showTierConfig = (tierConfig)=>{
    const fallback = companyRewardDetails?.exists ? 'existing' : 'new'
    setShowTiersModal(true);
    setTierConfig(tierConfig || fallback);
  }

  const onTierSelect = (selectedTier,points,tierConfig)=>{
    setSelectedPoints(points);
    setTierConfigDetails(tierConfig);
    setSelectedPlan(selectedTier);
    setShowMonthRangeModal(true);
    setShowTiersModal(false);
  }

  const NewConfigure = ()=>{
    window.console.log("hii")
    return(
      <ConfigureRewards margin={"20px 0px"} contentPadding={"50px 0px 0px 0px"} bg={ImageUrl + "/images/admin-rewards/new-reward-tier.png"} >
        <div className='content'>
          <div className='text'>Configure Rewards Points</div>
          <div className='sub-text'>Select a preset plan or set custom XP goals for each badge tier.</div>
          <CommonButtonPopup height="48px" width="200px" onClick={()=>showTierConfig('new')}>Set Tier Points</CommonButtonPopup>

        </div>

      </ConfigureRewards>
    )
  }

  const ExistingConfigure = (daysLeft)=>{
    window.console.log("hii")
    return(
      <ConfigureRewards height={'178px'} margin={"20px 0px"} contentPadding={"20px 0px"} bg={ImageUrl + "/images/admin-rewards/existing-reward-tier.png"} subTextMargin={'8px 0px 20px 0px'}>
        <div className='content'>
          <div className='text' style={{lineHeight:'30px'}}>Set Your Rewards Tier Goals</div>
          <div className='sub-text'>Choose Your Plan Only <strong>{daysLeft} Days Left</strong> To Expire Your Rewards Points Tier <br/> After {daysLeft} Days Points Will get Automatically Get Set Up For Next Year!</div>
          <CommonButtonPopup width="auto" onClick={()=>showTierConfig('existing')}>Configure Rewards Tiers</CommonButtonPopup>

        </div>

      </ConfigureRewards>
    )
  }
  if (loading) {
    return (
      <RewardsDashboard>
        <div className='top-cards'>
          {Array.from({ length: 4 }).map((_, index) => (
            <SkeletonLoder
              key={index}
              width="292px"
              height="190px"
              style={{ gap: "25px" }}
            />
          ))}
        </div>
      </RewardsDashboard>
    );
  }

  const onRewardTierEdit = (selectedEditTier)=>{
    const fallback = companyRewardDetails?.exists ? 'existing' : 'new'
    if(selectedEditTier?.tier_type === 'custom'){
      history.push({pathname:"/company/rewards/manage-tiers",state:{tierConfig:fallback,isEdit:true,rewardPeriodId:selectedEditTier.id}})
    }else{
      showTierConfig()
    }
  }

  const daysLeft = companyRewardDetails?.tiers[0]?.end_date ? dayjs(companyRewardDetails?.tiers[0]?.end_date).diff(dayjs(), "day") : null;
  
  return (
    
    <>
      <RewardsDashboard>
        {/* <div className='top-cards'>{loading ? Array.from({ length: 4 }).map((_, index) => (
          <SkeletonLoder
            key={index}
            width={"292px"}
            height={"190px"}
            style={{ gap: "25px" }}
          />
        )) : companyRewardDetails && <CompanyMedalCardsDashboard companyRewardDetails={companyRewardDetails?.company_tier} />}</div> */}
        {/* selectedYear?.year < new Date().getFullYear() */}

        {companyRewardDetails?.tiers?.length > 1 || selectedYear?.year < new Date().getFullYear() ? null : (companyRewardDetails?.exists && daysLeft <= 60) ? ExistingConfigure(daysLeft) : !companyRewardDetails?.exists ? NewConfigure() : null}
        
        <CompanyMedalCardsSlider companyRewardDetails={companyRewardDetails?.tiers} onRewardTierEdit={onRewardTierEdit}/>

        {showTiersModal && <TiersModal show={showTiersModal} onClose={()=>setShowTiersModal(false)} title={"Select Point Tier Levels"} modalWidth='938px' tierConfig={tierConfig} companyInfo={companyInfo} onTierSelect={onTierSelect}/>}

        {showMonthRangeModal && <MonthRangeModal show={showMonthRangeModal} title={'Select Month Range'} tierConfig={tierConfig} selectedStartMonth={selectedStartMonth} selectedEndMonth={selectedEndMonth} onMonthChange={onMonthChange} onCancel={()=>{setShowMonthRangeModal(false);setShowTiersModal(true)}} onConfirm={() =>{setShowPlanConfirmModal(true);setShowMonthRangeModal(false)}} tierConfigDetails={tierConfigDetails} />}

        {showPlanConfirmModal && <ConfirmPlanModal show={showPlanConfirmModal} title={'Confirm Your Plan'} tierConfig={tierConfig} selectedStartMonth={selectedStartMonth} selectedEndMonth={selectedEndMonth} selectedPlan={selectedPlan} points={selectedPoints} onCancel={()=>{setShowPlanConfirmModal(false);setShowMonthRangeModal(true);}} companyInfo={companyInfo} screen={'rewards'} history={history} fetchCompanyRewardsDetailsYearwise={fetchCompanyRewardsDetailsYearwise} onClose={()=>setShowPlanConfirmModal(false)}/>}
        <div style={{margin:'20px 0px'}}> <SpotPointsDashboard  leaders={spotPointsLeaders} totalPoints={spotPointsAwrded?.total_spot_points_awarded} selectedYear={selectedYear}  history={history}/></div>

      </RewardsDashboard>
    </>
  )
}

Rewards.propTypes = {
  selectedYear: PropTypes.string,
  companyInfo:PropTypes.object,
  history:PropTypes.object
}

export default Rewards